import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { Route as pathlessAuthenticatedRoute } from '../../../route';
import { DailyReportsPage } from './DailyReportsPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/item-master/utilities/daily-reports',
  staticData: {
    app: {
      access: {
        featureFlag: 'item-master-ui-enabled',
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Product }],
      },
    },
  },
  component: DailyReportsPage,
  loader: () => ({
    crumb: msg('Daily Reports', { context: 'page breadcrumb' }),
  }),
});
